import { render, staticRenderFns } from "./IdenticalFileNotice.vue?vue&type=template&id=1977dafc&scoped=true"
import script from "./IdenticalFileNotice.vue?vue&type=script&lang=js"
export * from "./IdenticalFileNotice.vue?vue&type=script&lang=js"
import style0 from "./IdenticalFileNotice.vue?vue&type=style&index=0&id=1977dafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977dafc",
  null
  
)

export default component.exports